import { store } from '../store/store';
import popupCloseButtonTypes from '../consts/popupCloseButtonTypes';
import alertTypes from '../consts/alertTypes';
import alertButtonTypes from '../consts/alertButtonTypes';
import alertResultTypes from '../consts/alertResultTypes';
import popupTypes from '../consts/popupTypes';

export default {

  install(Vue, options) {

    Vue.prototype.popupTypes = popupTypes;
    Vue.prototype.popupCloseButtonTypes = popupCloseButtonTypes;
    Vue.prototype.alertTypes = alertTypes;
    Vue.prototype.alertButtonTypes = alertButtonTypes;
    Vue.prototype.alertResultTypes = alertResultTypes;

    Vue.prototype.openPopup = (popup, data, handler = () => {}) => {
        store.commit('$openPopup', {
          popup,
          data,
          handler
        });
    };

    Vue.prototype.closePopup = () => {
        store.commit('$closePopup');
    };

    Vue.prototype.openAlert = (alert) => {
        store.commit('$openAlert', alert);
    };

  }

}



// WEBPACK FOOTER //
// ./src/helpers/popupModule.js